import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

/**
 * Angular wrapper service for file-saver library.
 */
@Injectable({
  providedIn: 'root',
})
export class FileSaverService {
  save(data: Blob | File, filename: string): void {
    saveAs(data, filename);
  }
}
